import React, { useEffect, useState, useContext } from 'react'

import { useLocation, Link } from 'react-router-dom'
import {
  Container,
  Grow,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  TextField,
  Toolbar
} from '@material-ui/core'
import DrawerComponent from '../../components/sidebar/Drawer'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import Resources from './Resources'
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined'
import ColorizeOutlinedIcon from '@mui/icons-material/ColorizeOutlined'
import HomeIcon from '@mui/icons-material/Home'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@mui/material/IconButton'
import { BarChart } from '@mui/x-charts/BarChart'
import Box from '@mui/material/Box'
import { DataGrid, GridColDef } from '@mui/x-data-grid'

import axios from 'axios'
import { apiUrl } from '../../context/constants/constants'
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary'
import SettingsIcon from '@mui/icons-material/Settings'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import InsertLinkIcon from '@mui/icons-material/InsertLink'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import MailIcon from '@mui/icons-material/Mail'
import { LineStyle, PowerSettingsNewOutlined } from '@material-ui/icons'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import LockIcon from '@mui/icons-material/Lock'
import moment from 'moment'
import { AuthContext } from '../../context/authContext/AuthContext'

export default function UserInfo() {
  const logoutFc = () => {
    localStorage.clear()
    window.location.reload()
  }
  const { user } = useContext(AuthContext)
  const [isVisible, setVisible] = useState(false)
  const toggle = () => {
    setVisible(!isVisible)
  }
  const [isVisible1, setVisible1] = useState(false)
  const toggle1 = () => {
    setVisible1(!isVisible1)
  }
  const [isVisible2, setVisible2] = useState(false)
  const toggle2 = () => {
    setVisible2(!isVisible2)
  }

  const [allResources, setAllResources] = useState([])
  const [resourcesByLaser, setResourcesByLaser] = useState([])
  const [resourcesByInjection, setResourcesByInjection] = useState([])
  const [open1, setOpen1] = useState(false)
  const handleClose1 = () => {
    setOpen1(!open1)
  }
  const [open2, setOpen2] = useState(false)
  const handleClose2 = () => {
    setOpen2(!open2)
  }

  let dataRedirect = useLocation()

  const [copied, setCopy] = useState(false)
  const [dataEnrollments, setDataEnrollments] = useState([])
  const [dataMonths, setDataMonths] = useState([])
  const [totalCommissions, setTotalCommissions] = useState(0)
  const [dataChart, setDataChart] = useState([])
  const [dataChart2, setDataChart2] = useState([])
  const [phoneValue, setPhoneValue] = useState('')

  const handleUpdate = async () => {
    if (formData.FirstName === '') {
      alert('First name is required!')
      return
    }
    if (formData.LastName === '') {
      alert('Last name is required!')
      return
    }
    if (formData.Email === '') {
      alert('Email is required!')
      return
    }
    if (formData.Phone === '') {
      alert('Phone is required!')
      return
    }
    if (phoneValue !== '') {
      formData.Phone = phoneValue
    }

    if (formData.NewPassword && formData.NewPassword !== '') {
      formData.Password = formData.NewPassword
    }

    if (formData.NewPassword !== formData.ConfirmPassword) {
      alert('Password and confirm password does not match!')
      return
    }
    try {
      const res = await axios.put(apiUrl + '/affiliate/updateUser', formData)
      alert(res.data.message)
    } catch (err) {
      console.log(err)
    }
  }
  const handleChange = (e) => {
    const { name, value } = e.target

    setFormData({ ...formData, [name]: value })
  }
  const [postData, setPostData] = useState({
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Password: '',
    AffiliateID: '',
    trackedUrl: '',
    lastUpdated: '',
    clicks: '',
    revenue: '',
    environments: '',
    commissionStructure1: '',
    commissionStructure2: '',
    commissionStructure3: ''
  })
  const [formData, setFormData] = useState({
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: phoneValue !== '' ? phoneValue : postData.Phone,
    Password: postData.Password,
    NewPassword: '',
    ConfirmPassword: '',
    userId: dataRedirect.state ? dataRedirect.state.userId : user.result._id
  })
  const removeDuplicates = (arr) => {
    return arr.filter((item, index) => arr.indexOf(item) === index)
  }
  const commissionStructure = (revenue) => {
    let commission = 0
    let commission1 = Number(postData.commissionStructure1)
    let commission2 = Number(postData.commissionStructure2)
    let commission3 = Number(postData.commissionStructure3)
    if (commission1 == '') {
      commission1 = 200
    }
    if (commission2 == '') {
      commission2 = 300
    }
    if (commission3 == '') {
      commission3 = 400
    }
    if (revenue <= 2500) {
      commission = commission1
    } else if (7000 > revenue && revenue >= 2501) {
      commission = commission2
    } else {
      commission = commission3
    }
    return commission
  }
  const getEnrollmentDetails = async (affiliateID) => {
    try {
      const res = await axios.get(
        `${apiUrl}/affiliate/getEnrollmentDetails/${affiliateID}`
      )

      if (res.data.success) {
        let dataEnrollments = res.data.data

        let commission = 0
        for (let i = 0; i < dataEnrollments.length; i++) {
          dataEnrollments[i].id = dataEnrollments[i]._id
          commission += commissionStructure(dataEnrollments[i].revenue)
        }

        setTotalCommissions(commission)
        setDataEnrollments(res.data.data)
        let groups = Object.groupBy(res.data.data, (item) =>
          moment(item.closeDate).format('MM-YYYY')
        )

        const result = Object.keys(groups).map((key) => groups[key])

        const dataArr = []
        const dataMonth = []
        const dataEnrollment = []
        for (var t = 0; t < result.length; t++) {
          let totalCommissionByMonth = 0
          let enrollments = 0
          for (var k = 0; k < result[t].length; k++) {
            enrollments += result[t][k].environment
            totalCommissionByMonth += commissionStructure(result[t][k].revenue)
            dataMonth.push(moment(result[t][k].closeDate).format('MM-YYYY'))
          }

          dataEnrollment.push(enrollments)
          //   let dataArrItem = {
          //     data: [totalCommissionByMonth]
          //   }
          dataArr.push(totalCommissionByMonth)
        }
        setDataChart(dataArr)
        setDataChart2(dataEnrollment)
        let dataMonth2 = removeDuplicates(dataMonth)
        setDataMonths(dataMonth2)
        //console.log('result2', result)
        // for (let g = 0; g < groups.length; g++) {
        //   console.log(g.revenue)
        // }
      }
    } catch (error) {
      console.log(error)
    }
  }
  const getUserInfoById = async (userId) => {
    try {
      const res = await axios.get(
        `${apiUrl}/affiliate/getUserInfoById/${userId}`
      )
      if (res.data.success) {
        setPostData({
          FirstName: res.data.data[0].FirstName,
          LastName: res.data.data[0].LastName,
          Email: res.data.data[0].Email,
          Phone: res.data.data[0].Phone,
          Password: res.data.data[0].Password,
          AffiliateID: res.data.data[0].AffiliateID,
          trackedUrl: res.data.data[0].trackedUrl,
          lastUpdated: res.data.data[0].lastUpdated,
          clicks: res.data.data[0].clicks,
          revenue: res.data.data[0].revenue,
          environments: res.data.data[0].environments,
          commissionStructure1: res.data.data[0].commissionStructure1,
          commissionStructure2: res.data.data[0].commissionStructure2,
          commissionStructure3: res.data.data[0].commissionStructure3
        })
        setFormData({
          FirstName: res.data.data[0].FirstName,
          LastName: res.data.data[0].LastName,
          Email: res.data.data[0].Email,
          Phone: res.data.data[0].Phone,
          Password: res.data.data[0].Password,
          userId: dataRedirect.state
            ? dataRedirect.state.userId
            : user.result._id
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const columns: GridColDef<(typeof rows)[number]>[] = [
    { field: 'id', headerName: 'ID', width: 1, hide: true, editable: true },
    {
      field: 'studentName',
      headerName: 'Student Name',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 160,
      valueGetter: (value, row) => {
        var lastName = row.studentName.split(' ').splice(-1)
        var firstName = row.studentName.slice(0, row.studentName.indexOf(' '))
        lastName = lastName[0].slice(0, 1)
        return `${firstName} ${lastName}`
      }
    },
    {
      field: 'revenue',
      headerName: 'Revenue',
      width: 150,
      editable: false,
      valueGetter: (value, row) => `$${row.revenue.toLocaleString()}`
    },
    {
      field: 'commision',
      headerName: 'Commission',
      width: 150,
      editable: false,
      valueGetter: (value, row) => `$${commissionStructure(row.revenue)}`
    },
    {
      field: 'closeDate',
      headerName: 'Completion Date',
      width: 140,
      editable: false
    }
  ]

  let rows = []
  if (dataEnrollments) {
    rows = dataEnrollments
  }

  const getAllResources = async () => {
    try {
      const resourceByInjection = []
      const resourceByLaser = []
      const res = await axios.get(`${apiUrl}/affiliate/getAllResources`)

      setAllResources(res.data.data)
      for (var i = 0; i < res.data.data.length; i++) {
        if (res.data.data[i].categoryLocation === 'Laser') {
          resourceByLaser.push(res.data.data[i])
        } else {
          resourceByInjection.push(res.data.data[i])
        }
      }
      setResourcesByInjection(resourceByInjection)
      setResourcesByLaser(resourceByLaser)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    let userId = ''
    let affiliateId = ''
    if (dataRedirect.state) {
      userId = dataRedirect.state.userId
    } else {
      userId = user.result._id
    }
    if (dataRedirect.state) {
      affiliateId = dataRedirect.state.affiliateId
    } else {
      affiliateId = user.result.affiliateId
    }

    getAllResources()
    getUserInfoById(userId)
    getEnrollmentDetails(affiliateId)
    // , data.state.userId, data.state.affiliateId
  }, [user, dataRedirect])
  return (
    <Grow in>
      <Container style={{ marginTop: '50px' }}>
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
          className='wrapper'
        >
          <div className='mainMenu'>
            <Grid item xs={12} sm={12} className='wrapUserHeader'>
              <div className='mainMenu'>
                <div className='wrapLogo'>
                  <div className='userLogo'>
                    <Link to={`${process.env.PUBLIC_URL}/`}>
                      <Typography
                        className='logoMain'
                        variant='h1'
                        style={{ fontWeight: '500', fontSize: '30px' }}
                      >
                        NATIONAL LASER
                      </Typography>
                      <Typography
                        className='logoSub'
                        variant='h2'
                        style={{ fontWeight: '100', fontSize: '20px' }}
                      >
                        INSTITUTE
                      </Typography>
                      <Typography
                        className='slogan'
                        variant='h6'
                        style={{
                          fontWeight: '100',
                          fontSize: '15px',
                          fontStyle: 'italic'
                        }}
                      >
                        20 Years of Excellence!
                      </Typography>
                    </Link>
                  </div>
                </div>
                <Toolbar className='toolbar'>
                  <DrawerComponent />
                </Toolbar>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} className='wrapUserMainNav'>
              <div className='UserMainNav'>
                <div className='mainNavLeft'>
                  <Typography
                    variant='h6'
                    style={{
                      fontWeight: '100',
                      fontSize: '15px',
                      fontStyle: 'italic'
                    }}
                  >
                    Affiliate Dashboard
                  </Typography>
                </div>
                <div className='mainNavRight'>
                  <Typography
                    variant='h6'
                    style={{
                      fontWeight: '100',
                      fontSize: '15px',
                      fontStyle: 'italic'
                    }}
                  >
                    {user && user.result.isAdmin === true
                      ? ''
                      : 'Welcome back,'}{' '}
                    {postData.FirstName} {postData.LastName}
                  </Typography>
                  <ul className='userMenuList'>
                    <li className='sidebarListItem'>
                      <Button onClick={() => handleClose2()}>
                        <PhotoLibraryIcon className='userMenuIcon' />
                        Resource
                      </Button>
                    </li>

                    <li className='sidebarListItem'>
                      <Button onClick={() => handleClose1()}>
                        <SettingsIcon className='userMenuIcon' />
                        Settings
                      </Button>
                    </li>
                    <li className='sidebarListItem' onClick={logoutFc}>
                      <PowerSettingsNewOutlined className='sidebarIcon' />
                      Logout
                    </li>
                  </ul>
                </div>
              </div>
            </Grid>
          </div>
          <div className='container'>
            <Grid item xs={12} sm={12} className='lastUpdated'>
              <Typography
                variant='h6'
                style={{ fontWeight: '100', fontSize: '15px' }}
              >
                <AccessTimeIcon /> Last Updated:{' '}
                {moment(postData.lastUpdated).format('MM/DD/YYYY hh:mm')}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} className='referralLink'>
              <Typography
                variant='h6'
                style={{ fontWeight: '100', fontSize: '15px' }}
              >
                <InsertLinkIcon /> Your referral link:{' '}
                <span className='referralSpan'>{postData.trackedUrl}</span>
                <CopyToClipboard
                  text={postData.trackedUrl}
                  onCopy={() => setCopy(true)}
                >
                  <Button>Copy</Button>
                </CopyToClipboard>
                {copied ? <span style={{ color: 'red' }}>Copied.</span> : null}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} className='commissionStructure'>
              <Typography
                variant='h6'
                style={{ fontWeight: '500', fontSize: '15px' }}
              >
                Commission Structure
              </Typography>
              <ul>
                <li>
                  ${postData.commissionStructure1} per enrollment (Revenue: $1 -
                  $2,500)
                </li>
                <li>
                  ${postData.commissionStructure2} per enrollment (Revenue:
                  $2,501 - $7,000)
                </li>
                <li>
                  ${postData.commissionStructure3} per enrollment (Revenue:
                  $7,001+)
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={12} className='totalClick sectionGroup'>
              <Typography
                variant='h6'
                style={{ fontWeight: '100', fontSize: '15px' }}
              >
                <OpenInNewIcon /> Total Click
              </Typography>
              <Typography
                variant='h3'
                style={{ fontWeight: '500', fontSize: '20px' }}
              >
                {postData.clicks}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} className='totalEnrollment sectionGroup'>
              <Typography
                variant='h6'
                style={{ fontWeight: '100', fontSize: '15px' }}
              >
                <SupervisorAccountIcon />
                Total Enrollments
              </Typography>
              <Typography
                variant='h3'
                style={{ fontWeight: '500', fontSize: '20px' }}
              >
                {postData.environments}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} className='totalEnrollment sectionGroup'>
              <Typography
                variant='h6'
                style={{ fontWeight: '100', fontSize: '15px' }}
              >
                <AttachMoneyIcon /> Total Commissions
              </Typography>
              <Typography
                variant='h3'
                style={{ fontWeight: '500', fontSize: '20px' }}
              >
                ${totalCommissions}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              className='monthlyPerformance sectionGroup'
            >
              <Typography
                variant='h6'
                style={{ fontWeight: '100', fontSize: '15px' }}
              >
                Monthly Performance
              </Typography>
              <BarChart
                sx={{
                  '& .MuiBarElement-series-uvId': {
                    display: 'none'
                  },
                  '& .MuiBarElement-series-pvId:nth-of-type(2n + 1)': {
                    fill: '#0f9488'
                  },
                  '& .MuiBarElement-series-pvId:nth-of-type(2n)': {
                    fill: '#7E22CE!important'
                  },
                  '& .MuiBarElement-root:nth-of-type(2n + 1) ': {
                    fill: '#0f9488'
                  },
                  '& .MuiBarElement-root:nth-of-type(2n)': {
                    fill: '#0f9488'
                  },
                  '& .MuiChartsLegend-root': {
                    display: 'none'
                  }
                }}
                height={290}
                margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
                series={[
                  {
                    data: dataChart2,
                    label: 'Enrollments',
                    id: 'uvId',
                    stack: 'total'
                  },
                  {
                    data: dataChart,
                    label: 'Commissions ($)',
                    id: 'pvId',
                    stack: 'total'
                  }
                ]}
                xAxis={[{ data: dataMonths, scaleType: 'band' }]}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              className='enrollmentDetails sectionGroup'
            >
              <Typography
                variant='h6'
                style={{ fontWeight: '100', fontSize: '15px' }}
              >
                Enrollment Details
              </Typography>
              <Box sx={{ height: 400, width: '100%' }}>
                <DataGrid
                  columnVisibilityModel={{
                    id: false
                  }}
                  getEstimatedRowHeight={() => 100}
                  getRowHeight={() => 'auto'}
                  rows={dataEnrollments}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 20
                      }
                    }
                  }}
                  pageSizeOptions={[5]}
                  disableRowSelectionOnClick
                />
              </Box>
            </Grid>
          </div>
        </Grid>
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
          className='wrapFooter'
        >
          <div className='container'>
            <div className='footer'>
              <Typography
                variant='h6'
                style={{ fontWeight: '100', fontSize: '15px' }}
              >
                <MailIcon /> Affiliate Support:{' '}
                <a href='mailto:affiliate@nationallaserinstitute.com'>
                  affiliate@nationallaserinstitute.com
                </a>
              </Typography>
            </div>
          </div>
        </Grid>
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
          className='floatFooterMenuMobile'
        >
          <div className='footerMenu'>
            <ul className='userMenuList'>
              <li className='sidebarListItem'>
                <Link to={`${process.env.PUBLIC_URL}/`}>
                  <Typography
                    variant='h6'
                    style={{ fontWeight: '100', fontSize: '15px' }}
                  >
                    <HomeIcon className='userMenuIcon' />
                    Home
                  </Typography>
                </Link>
              </li>
              <li className='sidebarListItem'>
                <Button onClick={() => handleClose2()}>
                  <Typography
                    variant='h6'
                    style={{ fontWeight: '100', fontSize: '15px' }}
                  >
                    <PhotoLibraryIcon className='userMenuIcon' />
                    Resource
                  </Typography>
                </Button>
              </li>

              <li className='sidebarListItem'>
                <Button onClick={() => handleClose1()}>
                  <Typography
                    variant='h6'
                    style={{ fontWeight: '100', fontSize: '15px' }}
                  >
                    <SettingsIcon className='userMenuIcon' />
                    Settings
                  </Typography>
                </Button>
              </li>
            </ul>
          </div>
        </Grid>
        <Dialog
          className='accountSettings'
          onClose={handleClose1}
          aria-labelledby='customized-dialog-title1'
          open={open1}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title1'>
            Account Settings
          </DialogTitle>
          <IconButton
            aria-label='close'
            onClick={handleClose1}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <form
              encType='multipart/form-data'
              autoComplete='off'
              noValidate
              className='formAddAffiliate'
            >
              <FormControl fullWidth className='formControl'>
                <div className='wrapFullName'>
                  <TextField
                    required
                    className='fileInput'
                    name='FirstName'
                    variant='outlined'
                    label='Enter First Name'
                    fullWidth
                    value={formData.FirstName || ''}
                    onChange={(e) => handleChange(e)}
                  />

                  <TextField
                    className='fileInput'
                    name='LastName'
                    required
                    variant='outlined'
                    label='Enter Last Name'
                    fullWidth
                    value={formData.LastName || ''}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </FormControl>
              <FormControl fullWidth className='formControl'>
                <PhoneInput
                  disableCountryCode={true}
                  placeholder='Enter phone number'
                  value={formData.Phone}
                  country={'us'}
                  onlyCountries={['us']}
                  masks={{ us: '(...) ...-....' }}
                  onChange={setPhoneValue}
                />
              </FormControl>
              <FormControl fullWidth className='formControl'>
                <TextField
                  className='fileInput'
                  name='Email'
                  required
                  variant='outlined'
                  label='Enter Email'
                  fullWidth
                  value={formData.Email || ''}
                  onChange={(e) => handleChange(e)}
                />
              </FormControl>
              <Typography
                variant='h6'
                style={{ fontWeight: '100', fontSize: '15px' }}
              >
                Change Password
              </Typography>
              <FormControl className='formControl' fullWidth>
                <TextField
                  id='demo-simple-select-password'
                  className='fileInput'
                  name='Password'
                  disabled={true}
                  variant='outlined'
                  label='Current Password'
                  type={!isVisible ? 'password' : 'text'}
                  autoComplete='true'
                  fullWidth
                  value={formData.Password || ''}
                  onChange={(e) => handleChange(e)}
                />
                <span className='icon' onClick={toggle}>
                  {isVisible ? <LockIcon /> : <LockOpenIcon />}
                </span>
              </FormControl>
              <FormControl className='formControl' fullWidth>
                <TextField
                  id='demo-simple-select-password-new'
                  className='fileInput'
                  name='NewPassword'
                  variant='outlined'
                  label='New Password'
                  type={!isVisible1 ? 'password' : 'text'}
                  autoComplete='true'
                  fullWidth
                  value={formData.NewPassword || ''}
                  onChange={(e) => handleChange(e)}
                />
                <span className='icon' onClick={toggle1}>
                  {isVisible1 ? <LockIcon /> : <LockOpenIcon />}
                </span>
              </FormControl>
              <FormControl className='formControl' fullWidth>
                <TextField
                  id='demo-simple-select-password-confirm'
                  className='fileInput'
                  name='ConfirmPassword'
                  variant='outlined'
                  label='Confirm New Password'
                  type={!isVisible2 ? 'password' : 'text'}
                  autoComplete='true'
                  fullWidth
                  value={formData.ConfirmPassword || ''}
                  onChange={(e) => handleChange(e)}
                />
                <span className='icon' onClick={toggle2}>
                  {isVisible2 ? <LockIcon /> : <LockOpenIcon />}
                </span>
              </FormControl>
              <Typography className='checkPassword'></Typography>
              <FormControl className='formControl' fullWidth>
                <Button
                  className='buttonCancel'
                  variant='contained'
                  color='primary'
                  size='large'
                  type='button'
                  onClick={handleClose1}
                  // disabled={isFetching}
                >
                  Cancel
                </Button>
                <Button
                  className='buttonSubmit'
                  variant='contained'
                  color='primary'
                  size='large'
                  type='button'
                  onClick={handleUpdate}
                  // disabled={isFetching}
                >
                  Save Changes
                </Button>
              </FormControl>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          className='marketingResources'
          open={open2}
          onClose={handleClose2}
          aria-labelledby='customized-dialog-title2'
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title2'>
            Marketing Resources
          </DialogTitle>
          <IconButton
            aria-label='close'
            onClick={handleClose2}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <Tabs className='userResources'>
              <TabList>
                <Tab>All Resources</Tab>
                <Tab>
                  Laser <CameraAltOutlinedIcon />
                </Tab>
                <Tab>
                  Injection <ColorizeOutlinedIcon />
                </Tab>
              </TabList>

              <TabPanel>
                <Grid item xs={12} sm={12}>
                  {allResources && allResources.length > 0 ? (
                    <Resources data={allResources} />
                  ) : (
                    'Resources not found!'
                  )}
                </Grid>
              </TabPanel>
              <TabPanel>
                <Grid item xs={12} sm={12}>
                  {resourcesByLaser && resourcesByLaser.length > 0 ? (
                    <Resources data={resourcesByLaser} />
                  ) : (
                    'Resources not found!'
                  )}
                </Grid>
              </TabPanel>
              <TabPanel>
                <Grid item xs={12} sm={12}>
                  {resourcesByInjection && resourcesByInjection.length > 0 ? (
                    <Resources data={resourcesByInjection} />
                  ) : (
                    'Resources not found!'
                  )}
                </Grid>
              </TabPanel>
            </Tabs>
          </DialogContent>
        </Dialog>
      </Container>
    </Grow>
  )
}
